import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type BankModuleSpecsFragment } from '../../../../api/fragments/BankModuleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import BankModuleUpdateForm from './BankModuleUpdateForm';

export type BankModuleUpdateDrawerProps = {
    module: BankModuleSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const BankModuleUpdateDrawer = ({ module, onClose, visible }: BankModuleUpdateDrawerProps) => {
    const { t } = useTranslation('bankModuleDetails');

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('bankModuleDetails:updateDrawer.cancelButton')}</Button>
                    <Button form="updateBankModule" htmlType="submit" type="primary">
                        {t('bankModuleDetails:updateDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('bankModuleDetails:updateDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <BankModuleUpdateForm module={module} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default BankModuleUpdateDrawer;

export const useUpdateBankModuleDrawer = (module: BankModuleUpdateDrawerProps['module']) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <BankModuleUpdateDrawer module={module} onClose={actions.close} visible={visible} />,
    };
};
